import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { CardContent } from '@material-ui/core';

const styles = () =>
  createStyles({
    CardContent: {
      minHeight: 100,
    },
  });

function Content({ classes }: WithStyles<typeof styles>): JSX.Element {
  return (
    <div>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid lg={6} xs={12} item>
          <Card>
            <CardContent className={classes.CardContent}>
              <Typography component="h1" align="center">
                These are some useful electrical engineering equations I like to have on hand for
                quick reference.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(Content);
